import { createFileRoute } from '@tanstack/react-router'

import { RolePermissionsPage } from '@/components/roles/role-permissions-page'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/settings/roles/$id',
)({
    component: RolePermissionsRoute,
})

function RolePermissionsRoute() {
    const { id } = Route.useParams()
    return <RolePermissionsPage id={id} />
}
